"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _uploadcareWidget = _interopRequireDefault(require("uploadcare-widget"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// Visual customization: https://uploadcare.com/cookbook/widget_visual/
var Uploader = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(Uploader, _Component);

  var _super = _createSuper(Uploader);

  function Uploader() {
    var _this;

    (0, _classCallCheck2["default"])(this, Uploader);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "uploader", null);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "widget", null);
    return _this;
  }

  (0, _createClass2["default"])(Uploader, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          onChange = _this$props.field.onChange,
          setFieldValue = _this$props.form.setFieldValue,
          fieldName = _this$props.fieldName;

      var widget = _uploadcareWidget["default"].Widget(this.uploader);

      if (onChange && typeof onChange === "function") {
        widget.onChange(function (file) {
          if (file) {
            file.done(function (info) {
              // set the value of the selected image to `src` field value
              setFieldValue(fieldName, info.cdnUrl);
            }).fail(function () {
              return onChange(null);
            });
          } else {
            onChange(null);
          }
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var widgetElement = _uploadcareWidget["default"].jQuery(this.uploader).next(".uploadcare--widget");

      var widget = widgetElement.data("uploadcareWidget");

      if (widget && widget.inputElement === this.uploader) {
        widgetElement.remove();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var UPLOADCARE_API_KEY = this.props.UPLOADCARE_API_KEY;
      return /*#__PURE__*/_react["default"].createElement("input", (0, _extends2["default"])({
        type: "hidden",
        ref: function ref(input) {
          return _this2.uploader = input;
        }
      }, this.props.field, {
        "data-crop": "",
        "data-public-key": UPLOADCARE_API_KEY,
        role: "uploadcare-uploader" // eslint-disable-line

      }));
    }
  }]);
  return Uploader;
}(_react.Component);

var _default = Uploader;
exports["default"] = _default;